import { Service } from '../Service';
export default class UserService extends Service {
    constructor(axios) {
        super(axios);
    }
}
export { UserService };
